import { Tooltip } from '@/modules/perseo-billing/components';
import { Typography } from '@/modules/perseo-billing/ui/react/src';

export type TErrorCode = {
  error: string;
  isCatMessage?: boolean;
};

export const ErrorCode = ({ error }: TErrorCode) => {
  if (!error) return null;

  return (
    <div className="co-flex co-gap-8px co-items-center">
      <Typography weight="semibold" color="neutral-grey-500" noWrap>
        {'Código de error: '}{' '}
        <span className="co-font-normal co-text-neutral-grey-500">{error}</span>
      </Typography>
      <Tooltip title="Este código es para uso interno de Paris." />
    </div>
  );
};
